import { useState } from "react";
import { FaGoogle } from "react-icons/fa";
import { useAuthActions } from "../../core_stores/useAuthStore";
import { colors } from "../../design/tokens";
import { AuthModalLayout } from "./components/AuthModalLayout";

export function AuthModal({
  isShown,
  canClose,
  additionalBtn,
  onClose,
}: {
  isShown: boolean;
  canClose: boolean;
  additionalBtn?: {
    label: string;
    onClick: () => void;
  };
  onClose: () => void;
}) {
  function handleClose() {
    onClose();
  }

  if (!isShown) {
    return null;
  }

  return (
    <AuthModalLayout canClose={canClose} onClose={handleClose}>
      <div className="w-full h-full flex items-center justify-center">
        <Info
          onSignedInWithGoogle={() => onClose()}
          additionalBtn={additionalBtn}
        />
      </div>
    </AuthModalLayout>
  );
}

function Info({
  additionalBtn,
  onSignedInWithGoogle,
}: {
  additionalBtn?: {
    label: string;
    onClick: () => void;
  };
  onSignedInWithGoogle: () => void;
}) {
  const { signInWithGoogle } = useAuthActions();
  const [isLoading, setIsLoading] = useState(false);

  const handleGoogleSignIn = async () => {
    if (isLoading) return;

    setIsLoading(true);
    try {
      await signInWithGoogle();
      onSignedInWithGoogle();
    } catch (error) {
      console.error("Sign in failed:", error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div
      className="flex w-full flex-col items-center justify-center
      h-full px-[5%] py-[10%] gap-10
    text-light-text-secondary dark:text-dark-text-secondary"
    >
      <span className="text-3xl font-[700] text-center text-light-text dark:text-dark-text">
        Log in or create free account
      </span>
      <span className="text-center font-[600]">
        In order to proceed you need to be logged in.
      </span>
      <div className="flex flex-col gap-4 w-[258px]">
        <button
          id="auth-modal-google-sign-in"
          onClick={handleGoogleSignIn}
          disabled={isLoading}
          className={`w-full h-[40px] bg-primary-blue disabled:opacity-50 disabled:cursor-not-allowed
            text-white font-medium rounded-full flex items-center justify-center gap-3
            transition-all duration-200 ${colors.hover.opacity}`}
        >
          {isLoading ? (
            <div className="w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin" />
          ) : (
            <>
              <FaGoogle />
              Continue with Google
            </>
          )}
        </button>
        {additionalBtn && (
          <button
            onClick={additionalBtn.onClick}
            className={`w-full h-[40px] bg-primary-blue disabled:opacity-50 disabled:cursor-not-allowed
            text-white font-medium rounded-full flex items-center justify-center gap-3
            transition-all duration-200 ${colors.hover.opacity}`}
          >
            {additionalBtn.label}
          </button>
        )}
      </div>
    </div>
  );
}
